import { AvailableWidget } from "ui/components/Grid/types";
import ContactInfoCard from "./components/ContactInfoCard/ContactInfoCard";
import ContactEmailCard from "./components/ContactEmailCard/ContactEmailCard";
import ContactPhoneCard from "./components/ContactPhoneCard/ContactPhoneCard";
import ContactAddressCard from "./components/ContactAddressCard/ContactAddressCard";
import ContactNoteCard from "./components/ContactNoteCard/ContactNoteCard";
import ContactInfoHeader from "./components/ContactInfoCard/components/ContactInfoHeader/ContactInfoHeader";
import ContactEmailHeader from "./components/ContactEmailCard/components/ContactEmailHeader/ContactEmailHeader";
import ContactNoteHeader from "./components/ContactNoteCard/components/ContactNoteHeader/ContactNoteHeader";
import { ContactEmailRef } from "./components/ContactEmailCard/types";
import { ContactDetailFormValues } from "services/api/contacts/types";
import { ContactPhoneRef } from "./components/ContactPhoneCard/types";
import ContactPhoneHeader from "./components/ContactPhoneCard/components/ContactPhoneHeader/ContactPhoneHeader";
import { ContactAddressRef } from "./components/ContactAddressCard/types";
import ContactAddressHeader from "./components/ContactAddressCard/components/ContactAddressHeader/ContactAddressHeader";
import { ContactNoteRef } from "./components/ContactNoteCard/types";
import ContactRepresentativeCard from "./components/ContactRepresentativeCard/ContactRepresentativeCard";
import ContactRepresentativeHeader from "./components/ContactRepresentativeCard/components/ContactRepresentativeHeader/ContactRepresentativeHeader";
import { ContactRepresentativeRef } from "./components/ContactRepresentativeCard/types";

export const CONTACT_AVAILABLE_WIDGETS = (
  t: (key: string) => string,
  contactDetail: ContactDetailFormValues,
  emailRef: React.RefObject<ContactEmailRef>,
  phoneRef: React.RefObject<ContactPhoneRef>,
  addressRef: React.RefObject<ContactAddressRef>,
  noteRef: React.RefObject<ContactNoteRef>,
  representativeRef: React.RefObject<ContactRepresentativeRef>,
  onEditContact: () => void,
): AvailableWidget[] => [
    {
      id: "widget-contact-info",
      name: t("admin.contact.widget.info.title"),
      icon: "",
      header: <ContactInfoHeader contactDetail={contactDetail} onAdd={onEditContact} />,
      component: <ContactInfoCard contactDetail={contactDetail} />,
    },
    {
      id: "widget-contact-email",
      name: t("admin.contact.widget.email.title"),
      icon: "",
      header: <ContactEmailHeader contactDetail={contactDetail} onAdd={() => emailRef.current?.openAddNew()} ></ContactEmailHeader>,
      component: <ContactEmailCard contactDetail={contactDetail} ref={emailRef} />,
    },
    {
      id: "widget-contact-phone",
      name: t("admin.contact.widget.phone.title"),
      icon: "",
      header: <ContactPhoneHeader contactDetail={contactDetail} onAdd={() => phoneRef.current?.openAddNew()} ></ContactPhoneHeader>,
      component: <ContactPhoneCard contactDetail={contactDetail} ref={phoneRef} />,
    },
    {
      id: "widget-contact-address",
      name: t("admin.contact.widget.address.title"),
      icon: "",
      header: <ContactAddressHeader contactDetail={contactDetail} onAdd={() => addressRef.current?.openAddNew()} ></ContactAddressHeader>,
      component: <ContactAddressCard contactDetail={contactDetail} ref={addressRef} />,
    },
    {
      id: "widget-contact-note",
      name: t("admin.contact.widget.note.title"),
      icon: "",
      header: <ContactNoteHeader contactDetail={contactDetail} onAdd={() => noteRef.current?.openAddNew()} />,
      component: <ContactNoteCard contactDetail={contactDetail} ref={noteRef} />,
    },
    ...(contactDetail.contactType?.id === "C" ? [{
      id: "widget-contact-representatives",
      name: "Povezane osobe",
      icon: "",
      header: <ContactRepresentativeHeader contactDetail={contactDetail} onAdd={() => representativeRef.current?.openAddNew()} />,
      component: <ContactRepresentativeCard contactDetail={contactDetail} ref={representativeRef} />,
    }] : []),
  ];
